<template>
  <div id="cctv_detail">
      <TemplateLayout>
          <!-- Page Heading -->
          <h1 class="h3 mb-2 text-gray-800"><router-link to="/cctv" class="text-gray-800">CCTV</router-link> / <b class="text-primary">{{$route.name}}</b></h1>
          <p class="mb-4">ผู้ดูแลระบบสามารถสร้างข้อมูล CCTV แก้ไขข้อมูล และสามารถลบ รวมถึงสามารถระบุตำแหน่งและโซนของ CCTV</p>

          <form method="post" @submit.prevent="saveCCTVDetail">
            <div class="card shadow mb-4">
                <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">กรอกข้อมูลรายละเอียด CCTV</h6>
                </div>
                <div class="card-body">
                    
                    <div class="row">
                        <div class="col-lg-7" style="border-right: 1px solid #ddd">
                            <div class="row">
                                <div class="col-lg-4">
                                    <label>ชื่อ CCTV</label>
                                    <input required type="text" v-model="cctv_name" class="form-control" />
                                </div>
                            </div>
                            <hr>
                            <div class=" text-primary">
                                เกี่ยวกับตำแหน่ง
                            </div>
                            <div class="row">
                                <div class="col-lg-4">
                                    <label>โซนที่ตั้ง</label>
                                    <select required type="text" v-model="zone_id" class="form-control">
                                        <option v-for="item in zone_option" :key="item.zone_id" :value="item.zone_id">{{item.zone_name}}</option>
                                    </select>
                                </div>
                                <div class="col-lg-8">
                                    <label>ที่ตั้ง CCTV</label>
                                    <input required type="text" v-model="detail" class="form-control" />
                                </div>
                                <div class="col-lg-8">
                                    <label>ตำแหน่งบนแผนที่ (Google Map)</label>
                                    <div class="input-group">
                                        <input required readonly type="text" v-model="locationMap" class="form-control" />
                                        <a href="javascript:;" class="input-group-append" @click="openModalGoogleMap">
                                            <span class="input-group-text bg-primary text-white">
                                                <i class="fas fa-map-marker-alt"></i>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="alert alert-primary">
                                <label><b class="text-primary">ทดสอบการเชื่อมต่อกล้อง CCTV</b></label>
                                <div><em for="" class="text-primary" style="font-size: 14px;">ระบุ IP</em></div>
                                <input placeholder="ระบุ IP" type="text" v-model="asset_id" class="form-control mb-2" />
                                <button type="button" @click="testConnection" class="btn btn-success">
                                    ทดสอบการเชื่อมต่อ
                                </button>
                                <div class="mt-2 small">
                                    <i class="text-muted">
                                        ระบุ IP ของกล้อง IP CCTV ที่ต้องการเพิ่มเพื่อทดสอบสถานะการเชื่อมต่อ
                                    </i>
                                </div> 
                                <div class="text-center">
                                    <input type="hidden" id="hdf_status" name="hdf_status" @change="changeStatusValue" v-model="status">
                                </div> 
                            </div>
                           
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button id="btnSaveData" type="submit" class="btn btn-primary">
                            <i class="fas fa-save fa-fw"></i>
                            บันทึกข้อมูล
                    </button>
                </div>
            </div>
          </form>

        <div class="modal" id="full-selectmap" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">ระบุตำแหน่ง</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body p-0">
                        <div class="divMap">
                            <div class="map-top-command">
                                <div class="pull-right" style="width: 400px;margin-left:5px;">
                                    <input type="text" class="form-control input-sm" id="txtSearchText" @keyup.enter="searchtextKeyPress"  placeholder="ค้นหาสถานที่"  />
                                </div>
                            </div>
                        </div>
                        <div id="googleMap" class="googleMap" style="width: 100%; height: 475px;"></div>
                    </div>
                    <div class="modal-footer">
                        <a href="javascript:;" @click="setLocationOK" class="btn btn-primary mt-2">
                            <i class="fas fa-check fa-fw"></i>
                            ตกลง
                        </a>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">ปิด</button>
                    </div>
                </div>
            </div>
        </div>

      </TemplateLayout>
  </div>
</template>

<script>

import TemplateLayout from "@/components/layout/TemplateLayout.vue";
import { MasterService } from '@/services/master.service';
import { CCTVService } from '@/services/cctv.service';
import { AlertService } from '@/services/alert.service';
//import { API_KEY } from '../../.env';

var _map = null;
var gmarkers = [];
var latitude_temp = "";
var longitude_temp = "";

export default {
  name: 'CCTV_Detail',
  components: {
    TemplateLayout
  },
  data() {
      return {
        zone_option: [],
        cctv_id: "",
        zone_id: "",
        asset_id: "",
        cctv_name: "",
        latitude: "",
        longitude: "",
        status: 0,
        detail: ""
      }
  },
  methods: {
      async bindOption()
      {
        this.zone_option = await MasterService.getMasterList("zone");
      },
      async bindDataDetail()
      {
        if(this.cctv_id != ""){
            const respons = await CCTVService.getCCTVDetail(this.cctv_id)
            this.cctv_id = respons.cctv_id;
            this.zone_id = respons.zone_id;
            this.cctv_idcctv_id = respons.cctv_id;
            this.asset_id = respons.asset_id;
            this.cctv_name = respons.cctv_name;
            this.latitude = respons.latitude;
            this.longitude = respons.longitude;
            this.status = respons.status;
            this.detail = respons.detail;
        }
      },
      async saveCCTVDetail()
      {
          if(AlertService.confirm(window.$("#btnSaveData"),"ยืนยันรายการ?")){
              AlertService.loading(true,"บันทึกรายการ");
              var datas = {
                  cctv_id : this.cctv_id,
                  zone_id : this.zone_id,
                  asset_id : this.asset_id,
                  cctv_name : this.cctv_name,
                  latitude : this.latitude,
                  longitude : this.longitude,
                  status: this.status,
                  detail: this.detail
              };
              const respons = await CCTVService.saveCCTVDetail(this.cctv_id,datas)
              if(respons.status == 200 && respons.data.cctv_id != "")
              { 
                if(this.cctv_id == ""){
                    AlertService.success(respons.message)
                    this.cctv_id = respons.data.cctv_id;
                    setTimeout(() => {
                        this.$router.push({ path: `cctv_detail/`+respons.data.cctv_id })
                    }, 1500);
                    //AlertService.successRedirect(respons.message,"cctv_detail/"+respons.data.cctv_id)
                }else{
                    this.bindDataDetail();
                    AlertService.success(respons.message)
                }
              }else{
                AlertService.error(respons.message)
              }
              AlertService.loading(false)
          }
          return false;
      },
      openModalGoogleMap(){
            // if(window.document.getElementById("script-google-map") == null){
            //     var script = window.document.createElement('script');
            //     script.id = "script-google-map";
            //     script.src = `https://maps.google.com/maps/api/js?libraries=places,geometry`+ (API_KEY != "" ? `&key=${API_KEY}` : "");
            //     window.document.body.appendChild(script);
            // }
            window.$("#full-selectmap").modal("show");
            latitude_temp = (this.latitude == undefined || this.latitude == "" ? 13.8815777 : this.latitude);
            longitude_temp = (this.longitude == undefined || this.longitude == "" ? 100.3742956 : this.longitude);

            setTimeout(() => {
                //if(_map == null){
                    var mapProp = {
                        center: new window.google.maps.LatLng(13.8815777,100.3742956),
                        zoom: 16,
                        disableDoubleClickZoom: true,
                        //disableDoubleClickZoom: ไม่ให้ใช้ DoubleClick ในการ zoom ให้กดปุ่มเว้นวรรค บนคีย์บอร์ดแทน
                        mapTypeId: window.google.maps.MapTypeId.SATELLITE
                    };
                    _map = new window.google.maps.Map(window.document.getElementById("googleMap"), mapProp);
                    var marker = new window.google.maps.Marker({
                        map: _map,
                        draggable: true,
                        position: new window.google.maps.LatLng(latitude_temp, longitude_temp)
                    });
                    //แอด event ให้ google marker เลื่อนจุดได้
                    marker.addListener('drag', function(event) {
                        latitude_temp = event.latLng.lat();
                        longitude_temp = event.latLng.lng();
                    });
                    marker.addListener('dragend', function(event) {
                        latitude_temp = event.latLng.lat();
                        longitude_temp = event.latLng.lng();
                    });
                    gmarkers.push(marker);
                    // createMarkerFromLatLng ใช้สร้าง Marker ครั้งแรกสร้างที่ประเทศไทย
                    window.google.maps.event.addListener(_map, 'dblclick', function(event) {
                        latitude_temp = event.latLng.lat();
                        longitude_temp = event.latLng.lng();
                        //เอา Marker ออก
                        for (var i = 0; i < gmarkers.length; i++) {
                            gmarkers[i].setMap(null);
                        }
                        //ชี้ Marker ที่จุดใหม่ เมื่อทำการ DoubleClick
                        var marker = new window.google.maps.Marker({
                            map: _map,
                            draggable: true,
                            position: new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng())
                        });
                        //แอด event ให้ google marker เลื่อนจุดได้
                        marker.addListener('drag', function(event) {
                            latitude_temp = event.latLng.lat();
                            longitude_temp = event.latLng.lng();
                        });
                        marker.addListener('dragend', function(event) {
                            latitude_temp = event.latLng.lat();
                            longitude_temp = event.latLng.lng();
                        });
                        gmarkers.push(marker);
                    });

                // }else{
                //     window.google.maps.event.trigger(window.map, 'resize');
                //     _map.setZoom(_map.getZoom());
                //     _map.setCenter(new window.google.maps.LatLng(this.latitude, this.longitude));
                // }
            }, 600);
      },
      searchtextKeyPress(){
        var address = window.document.getElementById('txtSearchText').value;
        if(address != ""){
            var geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ 'address': address }, function (results, status) {
                if (status === 'OK') {
                    _map.setCenter(results[0].geometry.location);
                    this.createMarker(results[0]);
                    latitude_temp = results[0].geometry.location.lat();
                    longitude_temp = results[0].geometry.location.lng();
                }
            });
        }
      },
      createMarker(place) {
        var marker = new window.google.maps.Marker({
            map: _map,
            position: place.geometry.location
        });
        gmarkers.push(marker);
        window.google.maps.event.addListener(marker, 'click', function () {
            window.infowindow.setContent(place.name);
            window.infowindow.open(_map, marker);
        });
      },
      setLocationOK(){
        window.$("#full-selectmap").modal('hide');
        this.latitude = latitude_temp;
        this.longitude = longitude_temp;
      },
      async testConnection(){
        if(this.asset_id == ""){
            AlertService.error("กรุณาระบุข้อมูลให้ครบถ้วน ในการทดสอบการเชื่อมต่อ");
            return;
        }
        window.AlertLoading(true,"ทดสอบการเชื่อมต่อ");

        // try {
        //     var ws = new WebSocket(this.asset_id);
        //     ws.onopen = function () {
        //         //document.getElementById("connectionStatus").innerHTML = "Connected";
        //     };
        //     ws.onmessage = function () {
        //         ws.close();
        //         AlertService.success("Online Status.");
        //         var el = document.getElementById("hdf_status");
        //         el.value = 1;
        //         el.dispatchEvent(new Event('change'))
        //     };
        //     ws.onerror = function() {
        //         //console.error("WebSocket error observed:", event);
        //         AlertService.error("Offline Status.");
        //         var el = document.getElementById("hdf_status");
        //         el.value = 0;
        //         el.dispatchEvent(new Event('change'))
        //     };
        //     ws.onclose = function () {
        //         //document.getElementById("connectionStatus").innerHTML = "Disconnected";
        //         window.AlertLoading(false);
        //     };
        // } catch (e) {
        //     window.AlertLoading(false);
        //     AlertService.error("Offline Status.");
        //     var el = document.getElementById("hdf_status");
        //     el.value = 0;
        //     el.dispatchEvent(new Event('change'))
        // }
        
        try {
            this.status = 0;
            const res = await CCTVService.testConnectCheckServer(this.asset_id)
            if(res.data != undefined && res.data.status != undefined && res.data.status == "1"){
                this.status = 1;
                AlertService.success("Online Status.");
            }else{
                AlertService.error("Offline Status.");
            }
        } catch (error) {
            console.log(error);
            AlertService.error("Offline Status.");
        }
        window.AlertLoading(false);
      },
      changeStatusValue(){
          this.status = document.getElementById("hdf_status").value;
      }
  },
  computed: {
    locationMap: function () {
        if(this.latitude == undefined || this.latitude == ""){
            return "";
        }
        return this.latitude + ',' + this.longitude
    }
  },
  mounted() {
    this.cctv_id = (this.$route.params.id == undefined ? "" : this.$route.params.id);
    this.bindOption();
    this.bindDataDetail();
  },
}

</script>

<style>
.divMap {
    position: relative;
}
.map-top-command {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 2;
}
.map-top-command .form-control {
    display: inline-block;
}
.googleMap {
    z-index: 1;
}
</style>